/**
 * '로그인 유지' 선택을 기기에 기억한다.
 *
 * 선택 자체는 자격 증명이 아니라 취향이므로 저장해도 안전하다.
 * 기본값은 꺼짐 — 공용 기기에서 무심코 로그인이 남지 않게 한다.
 */

const STORAGE_KEY = 'shorty-remember-me'

export function readRememberMe(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function storeRememberMe(remember: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(remember))
  } catch {
    // 저장 실패는 로그인 자체에 영향을 주지 않는다
  }
}
